import { CrossTabMessage } from './cross-tab-message';

/**
 * デザイン編集の作業コピーが保存・破棄で畳まれた。
 * 送り手・受け手: src/sections/v2/theme/view/design-editor-hooks/use-editor-cross-tab-sync.js
 *
 * 作業コピーの帰属は編集コンテキスト（サイト+テーマ+ユーザー）なので、
 * 受け手は isFor(siteId, themeCode) で自分の画面宛てかを見る。
 */
export class WorkingCopySettledMessage extends CrossTabMessage {
    static topic = 'design_editor/working_copy_settled';

    static fromFields({ siteId, themeCode, scope, targetId, reason, revision }) {
        if (typeof siteId !== 'string' || !siteId) return null;
        if (typeof themeCode !== 'string' || !themeCode) return null;
        if (typeof scope !== 'string' || !scope) return null;
        return new WorkingCopySettledMessage({ siteId, themeCode, scope, targetId, reason, revision });
    }

    /**
     * @param {object} f
     * @param {string} f.siteId
     * @param {string} f.themeCode
     * @param {string} f.scope     'page' | 'site' | 'form' | 'code' | …
     * @param {string} [f.targetId]
     * @param {string} [f.reason]  'saved' | 'ai' | 'deleted' | …
     * @param {number} [f.revision] 破棄 API が返した世代（無ければ null）
     */
    constructor({ siteId, themeCode, scope, targetId, reason, revision }) {
        super({ siteId });
        this.themeCode = themeCode;
        this.scope = scope;
        this.targetId = targetId || null;
        this.reason = reason || null;
        this.revision = revision ?? null;
    }

    isFor(siteId, themeCode) {
        return !!siteId && this.siteId === siteId && this.themeCode === themeCode;
    }
}

CrossTabMessage.register(WorkingCopySettledMessage);
